const awsIam = `<ListRolesResponse xmlns="https://iam.amazonaws.com/doc/2010-05-08/">
  <ListRolesResult>
    <IsTruncated>false</IsTruncated>
    <Marker>AEVgXdAxaVtfpp9Sh4x6f1Y7L/ualMB5DCTnY2WQieJHiFgQGzGg9c3P0ndqTceiOUTCQ0u8+o9oya/oAkzbk3MMI80YJSNrViWX0VnoNKaS6VzOoVJFTF1ZjaUtdYTNqF4Bf3wptQehA9fiV/nBaWD4Hf/nOTSsZzU=</Marker>
    <Roles>
      <member>
        <Path>/</Path>
        <AssumeRolePolicyDocument>%7B%22Version%22%3A%222012-10-17%22%2C%22Statement%22%3A%5B%7B%22Effect%22%3A%22Allow%22%2C%22Principal%22%3A%7B%22Service%22%3A%22ec2.amazonaws.com%22%7D%2C%22Action%22%3A%22sts%3AAssumeRole%22%7D%5D%7D</AssumeRolePolicyDocument>
        <MaxSessionDuration>3600</MaxSessionDuration>
        <RoleId></RoleId>
        <RoleName>Cloud-Manager-Operator-3O3HlLn</RoleName>
        <Description/>
        <Arn>arn:aws:iam::210811600188:role/Cloud-Manager-Operator-3O3HlLn</Arn>
        <CreateDate>2025-05-07T11:12:50Z</CreateDate>
      </member>
    </Roles>
  </ListRolesResult>
  <ResponseMetadata>
    <RequestId>a4ffad64-90c8-4f36-a7d7-72e985bfebdf</RequestId>
  </ResponseMetadata>
</ListRolesResponse>
`

export default awsIam;
